<template>
  <v-container class="grey-lighten-3 full-height">
    <v-row justify="center">
      <v-col cols="12" xl="10">
        <v-sheet class="report-paper pa-6" elevation="3" id="printable-area">
          <div v-if="loading || (!code && !receive_id)" class="text-center">
            <p>Loading receive details...</p>
          </div>

          <div v-else>
            <div class="watermark">
              <img v-if="getCurrentCompany?.logo" :src="getFileServerUrl + getCurrentCompany?.logo" alt="">
            </div>

            <div class="invoice-container">
              <div class="invoice-content">
                <table style="width: 100%; border-collapse: collapse;">
                  <thead>
                    <tr v-if="getCurrentCompany?.header_image">
                      <td colspan="100%">
                        <img :src="`${getFileServerUrl}${getCurrentCompany?.header_image}`" style="width: 100%;" alt="">
                      </td>
                    </tr>
                  </thead>

                  <tbody>
                    <!-- Header Section -->
                    <tr v-if="!getCurrentCompany?.header_image">
                      <td colspan="100%">
                        <div class="page-header">
                          <div class="header-section d-flex justify-space-between align-start">
                            <div class="company-info">
                              <h4 class="company-name">{{ getCurrentCompany?.name || '' }}</h4>
                              <p class="company-text">{{ getCurrentCompany?.address || '' }}</p>
                              <p class="company-text">
                                <v-icon size="small">mdi-phone-outline</v-icon>
                                {{ getCurrentCompany?.mobile || '' }}
                              </p>
                              <p class="company-text">
                                <v-icon size="small">mdi-email-outline</v-icon>
                                {{ getCurrentCompany?.email || '' }}
                              </p>
                            </div>
                            <div class="logo-container">
                              <v-img
                                :src="`${getFileServerUrl}/${getCurrentCompany?.logo || 'uploads/demo_images/user.png'}`"
                                max-width="150" max-height="70" contain />
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <!-- Title Section -->
                    <tr>
                      <td colspan="100%">
                        <div class="report-title">
                          <h4>DIRECT RECEIVE</h4>
                        </div>
                      </td>
                    </tr>

                    <!-- Supplier and Receive Info -->
                    <tr>
                      <td colspan="100%">
                        <table class="meta-table">
                          <tbody>
                            <tr style="display:flex; gap:6px">
                              <td style="width: 50%; vertical-align: top;">
                                <div class="meta-box">
                                  <strong>SUPPLIER:</strong><br>
                                  <span class="supplier-name">{{ supplier?.name || supplier?.supplier_name || 'N/A'
                                    }}</span><br>
                                  <span v-if="supplier?.address || supplier?.supplier_address">{{ supplier.address ||
                                    supplier.supplier_address }}</span><br
                                    v-if="supplier?.address || supplier?.supplier_address">
                                  <v-icon size="small"
                                    v-if="supplier?.mobile || supplier?.supplier_mobile">mdi-phone-outline</v-icon>
                                  <span v-if="supplier?.mobile || supplier?.supplier_mobile">{{ supplier.mobile ||
                                    supplier.supplier_mobile }}</span><br
                                    v-if="supplier?.mobile || supplier?.supplier_mobile">
                                  <v-icon size="small"
                                    v-if="supplier?.email || supplier?.supplier_email">mdi-email-outline</v-icon>
                                  <span v-if="supplier?.email || supplier?.supplier_email">{{ supplier.email ||
                                    supplier.supplier_email }}</span>
                                </div>
                                <div class="meta-box" v-if="shipping_address">
                                  <strong>Shipping Address:</strong><br>
                                  {{ shipping_address }}
                                </div>
                              </td>
                              <td style="width: 50%; vertical-align: top;">
                                <div class="meta-box">
                                  <strong>RECEIVE #: </strong>{{ code }}<br>
                                  <strong>RECEIVE DATE: </strong>{{ formatDateView(receive_date) }}<br>
                                  <strong>SHIPPING DATE: </strong><span v-if="shipping_date">{{
                                    formatDateView(shipping_date) }}</span><span v-else>N/A</span><br>
                                  <strong>WAREHOUSE: </strong>{{ warehouse?.name || 'N/A' }}
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    <!-- Products Table -->
                    <tr>
                      <td colspan="100%">
                        <table class="dep-table">
                          <thead>
                            <tr>
                              <th>SN</th>
                              <th>Code</th>
                              <th>Item</th>
                              <th>Lot No.</th>
                              <th class="text-center">Quantity</th>
                              <th class="text-center">Unit</th>
                              <th class="text-right">Rate</th>
                              <th class="text-right">Amount</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(product, key) in cart" :key="product.product_id || key">
                              <td>{{ key + 1 }}</td>
                              <td>{{ product.product_code || '' }}</td>
                              <td>{{ product.product_name || '' }}</td>
                              <td>{{ product.lot_no }}</td>
                              <td class="text-center">{{ product.qty || 0 }}</td>
                              <td class="text-center">{{ product.unit_name || '' }}</td>
                              <td class="text-right">{{ $numberFormat(product.rate || 0) }}</td>
                              <td class="text-right">{{ $numberFormat(product.total || (product.qty * product.rate) ||
                                0) }}</td>
                            </tr>
                            <tr v-if="cart.length === 0">
                              <td colspan="7" class="text-center">No product details found</td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    <!-- Total and Remarks -->
                    <tr>
                      <td colspan="100%">
                        <div class="total-section">
                          <table class="total-table">
                            <tbody>
                              <tr>
                                <td style="width: 70%;">
                                  <strong>TOTAL AMOUNT</strong><br>
                                  <strong>Amount in Words: </strong>{{ convertNumberToWords(total_amount || 0) }}
                                </td>
                                <td style="width: 30%;" class="text-right">
                                  <strong>{{ $numberFormat(total_amount || 0) }}</strong>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div v-if="remarks" class="remarks-section">
                          <strong>Remarks:</strong> {{ remarks }}
                        </div>
                      </td>
                    </tr>

                    <!-- Signature Section -->
                    <tr>
                      <td colspan="100%">
                        <div class="signature-section">
                          <table style="width: 100%; margin-top: 50px;">
                            <tbody>
                              <tr>
                                <td style="width: 33%; text-align: center;">
                                  <div class="signature-line">
                                    Receiver's Signature
                                  </div>
                                </td>
                                <td style="width: 33%;"></td>
                                <td style="width: 33%; text-align: center;">
                                  <div class="signature-line">
                                    {{ getCurrentCompany?.name || 'Company Name' }}
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div class="d-print-none text-center mt-6">
            <v-btn color="primary" class="mr-2" @click="printReceive">
              <v-icon left>mdi-printer</v-icon> Print
            </v-btn>
            <v-btn color="success" @click="downloadReceive(receive_id)">
              <v-icon left>mdi-file-pdf-box</v-icon> Download PDF
            </v-btn>
          </div>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import convertNumberToWords from "@/plugins/numberToWord";
import { formatDateView, formatDateDash } from "@/plugins/helpers";
import { toast } from "vue3-toastify";
import html2pdf from "html2pdf.js";
import { generatePrintHeaderWithWatermark, generatePrintFooter, getCurrentCompanyForPrint } from "@/utils/printHeader";
import { fileServerUrl } from "@/store/api";

export default {
  data() {
    return {
      receive_id: '',
      code: '',
      receive_date: '',
      shipping_date: '',
      shipping_address: '',
      remarks: '',
      total_amount: 0,
      total_item: 0,
      supplier: {},
      warehouse: {},
      cart: [],
      loading: false
    };
  },
  methods: {
    convertNumberToWords,
    formatDateView,

    async downloadReceive(id) {
      try {
        const element = document.getElementById("printable-area");
        if (!element) {
          toast.error("No content to export");
          return;
        }

        // Get current company information
        const company = getCurrentCompanyForPrint(this.$store);

        // Generate header with watermark and footer
        const headerHTML = company ? generatePrintHeaderWithWatermark(company, fileServerUrl, {
          watermarkOpacity: 0.03
        }) : '';
        const footerHTML = company ? generatePrintFooter(company, fileServerUrl) : '';

        // Clone and clean the content for PDF generation
        const clonedElement = element.cloneNode(true);

        // Remove the watermark and header sections from the cloned content
        const watermarkDiv = clonedElement.querySelector('.watermark');
        if (watermarkDiv) {
          watermarkDiv.remove();
        }

        const tableHead = clonedElement.querySelector('thead');
        if (tableHead) {
          tableHead.remove();
        }

        // Remove the company info row if no header image (traditional header)
        const headerRows = clonedElement.querySelectorAll('tbody tr');
        if (headerRows.length > 0 && !this.getCurrentCompany?.header_image) {
          const firstRow = headerRows[0];
          if (firstRow.querySelector('.company-info, .company-name')) {
            firstRow.remove();
          }
        }

        // Create a temporary container with header, cleaned content, and footer
        const tempContainer = document.createElement('div');
        tempContainer.innerHTML = `
          <div style="position: relative; min-height: 100vh;">
            <div style="padding: 20px;">
              ${headerHTML}
              <div style="margin-top: 20px;">
                ${clonedElement.innerHTML}
              </div>
            </div>
            ${footerHTML}
          </div>
        `;

        // Copy styles from the original element
        tempContainer.style.cssText = element.style.cssText;
        tempContainer.className = element.className;

        // Hide the temp container
        tempContainer.style.position = 'absolute';
        tempContainer.style.left = '-9999px';
        tempContainer.style.top = '-9999px';
        document.body.appendChild(tempContainer);

        const opt = {
          margin: [1, 0.5, 1, 0.5], // top, right, bottom, left
          filename: `direct-receive-${this.code || id}.pdf`,
          image: { type: "jpeg", quality: 0.98 },
          html2canvas: {
            scale: 2,
            useCORS: true,
            allowTaint: true,
            logging: false,
            backgroundColor: "#ffffff",
            scrollX: 0,
            scrollY: 0,
            windowWidth: 1024,
            windowHeight: 768
          },
          jsPDF: {
            unit: "cm",
            format: "a4",
            orientation: "portrait"
          }
        };

        await html2pdf().set(opt).from(tempContainer).save();

        // Clean up
        document.body.removeChild(tempContainer);

        toast.success("PDF downloaded successfully");
      } catch (error) {
        console.error("PDF generation failed:", error);
        toast.error("Failed to generate PDF");
        // Fallback to print if PDF generation fails
        this.printReceive();
      }
    },

    async printReceive() {
      // Clone the printable area to modify it for printing
      const printableElement = document.getElementById("printable-area");
      const clonedElement = printableElement.cloneNode(true);

      // Remove the watermark and header sections from the cloned content
      // since we're providing them separately
      const watermarkDiv = clonedElement.querySelector('.watermark');
      if (watermarkDiv) {
        watermarkDiv.remove();
      }

      // Remove the table header that contains company header image
      const tableHead = clonedElement.querySelector('thead');
      if (tableHead) {
        tableHead.remove();
      }

      // Remove the company info row if no header image (traditional header)
      const headerRows = clonedElement.querySelectorAll('tbody tr');
      if (headerRows.length > 0 && !this.getCurrentCompany?.header_image) {
        // Check if the first row contains company info
        const firstRow = headerRows[0];
        if (firstRow.querySelector('.company-info, .company-name')) {
          firstRow.remove();
        }
      }

      const printContent = clonedElement.innerHTML;
      const printWindow = window.open("", "_blank", `width=${screen.width}, height=${screen.height}`);

      // Get current company information
      const company = getCurrentCompanyForPrint(this.$store);

      // Generate header with watermark and footer
      const headerHTML = company ? generatePrintHeaderWithWatermark(company, fileServerUrl, {
        watermarkOpacity: 0.05
      }) : '';
      const footerHTML = company ? generatePrintFooter(company, fileServerUrl) : '';

      printWindow.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
          <meta charset="UTF-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>Direct Receive</title>
          <link href="https://cdn.jsdelivr.net/npm/@mdi/font@7.4.47/css/materialdesignicons.min.css" rel="stylesheet">
          <style>
            * {
              margin: 0;
              padding: 0;
              box-sizing: border-box;
            }

            @page {
              size: A4;
              margin: 0px 10px;
              padding: 0;
            }

            html, body {
              margin: 0;
              padding: 0;
              width: 100%;
              height: auto;
            }

            body {
              font-family:"Times New Roman", serif;
              background:#fff;
              color:#000;
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
              margin: 0;
              padding: 0;
            }

            .report-paper {
              width: 100%;
              padding: 0 !important;
              background: #fff;
              margin: 0;
            }

            .invoice-container {
              width: 100%;
              margin: 0;
              padding: 0;
            }

            .invoice-content {
              width: 100%;
              margin: 0;
              padding: 0;
            }

            table {
              width: 100%;
              border-collapse: collapse;
              margin: 0;
              padding: 0;
            }

            th, td {
             
              padding: 6px;
              text-align: left;
              vertical-align: top;
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }

            th {
              background: #e0e0e0;
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }

            .text-center { text-align: center; }
            .text-right { text-align: right; }

            .company-name {
              font-size: 20px;
              font-weight: bold;
              text-transform: uppercase;
            }

            .company-text { font-size: 14px; }

            .report-title {
              font-size: 20px;
              text-align: center;
              margin: 8px 0;
            }

            .meta-box {
              border: 1px solid #000;
              padding: 8px;
              font-size: 13px;
              margin-bottom: 16px;
            }

            .supplier-name { font-weight: bold; }

            .total-section { margin: 20px 0; }
            .total-table { width: 100%; margin-bottom: 20px; }
            .remarks-section { margin: 20px 0; padding: 10px; border: 1px solid #ddd; }

            .signature-section { margin-top: 50px; }
            .signature-line {
              border-top: 1px solid #555;
              width: 200px;
              margin: 0 auto;
              text-align: center;
              color: #333;
              padding-top: 10px;
            }

            .watermark {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              z-index: 0;
              opacity: 0.1;
            }

            .page-header { margin-bottom: 20px; }
            .header-section { margin-bottom: 20px; }
            .company-info { flex: 1; }
            .logo-container { flex-shrink: 0; }

            /* Print header styles */
            .container-fluid { margin: 0; padding: 0; }
            .position-relative { position: relative; }
            .watermark { opacity: 0.1; }

            @media print {
              body {
                margin: 0;
                padding: 0;
              }

              .watermark {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                z-index: 0;
                opacity: 0.1;
              }

              .report-paper {
                box-shadow: none !important;
                border: none !important;
              }

              .d-print-none {
                display: none !important;
              }
            }
          </style>
        </head>
        <body>
          ${headerHTML}
          <div style="margin-top: 20px;">
            ${printContent}
          </div>
          ${footerHTML}
        </body>
        </html>
      `);

      printWindow.document.close();
      printWindow.focus();
      setTimeout(() => printWindow.print(), 500);
    },

    formatNumber(value) {
      if (!value) return '0.00';
      return parseFloat(value).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }
  },
  computed: {
    getCurrentCompany() {
      return this.$store.getters.getCurrentCompany || {};
    },
    getFileServerUrl() {
      return this.$store.getters.getFileServerUrl || '';
    },
  },
  mounted() {
    const id = this.$route.params.id;
    if (id) {
      this.loading = true;
      this.$store.commit("SET_LOADING", { color: "primary" });
      this.$nextTick(() => {
        this.$store
          .dispatch("getInvDirectReceiveById", id)
          .then((data) => {
            this.loading = false;
            let receive = data;
            this.receive_id = receive.id;
            this.code = receive.code || '';
            this.receive_date = receive.receive_date || '';
            this.shipping_date = receive.shipping_date || '';
            this.shipping_address = receive.shipping_address || '';
            this.remarks = receive.remarks || '';
            this.total_amount = receive.amount || 0;
            this.total_item = receive.total_item || 0;

            this.supplier = receive.supplier || {};
            this.warehouse = receive.warehouse || {};

            this.cart = [];
            // Handle both camelCase and snake_case relationship names
            const details = receive.InvDrReceiveDetails ||
              receive.inv_dr_receive_details ||
              receive.invDrReceiveDetails ||
              [];
            details.forEach((item) => {
              this.cart.push({
                product_id: item.product_id,
                product_name: item.product?.name || "",
                product_code: item.product?.code || "",
                lot_no: item.lot_no,
                qty: item.qty || 0,
                unit_name: item.product?.unit?.name || "",
                rate: item.rate || 0,
                total: item.amount || (item.qty * item.rate) || 0,
              });
            });
            this.$store.commit("UNSET_LOADING");
          })
          .catch((error) => {
            this.loading = false;
            console.error("Failed to fetch direct receive:", error);
            toast.error("Failed to load direct receive details");
            this.$store.commit("UNSET_LOADING");
          });
      });
    } else {
      toast.error("No receive ID provided");
      this.$router.push({ name: "direct-receive-records" });
    }
  },
};
</script>

<style scoped>
.full-height {
  min-height: 60vh;
}

.grey-lighten-3 {
  background-color: #eeeeee !important;
}

.report-paper {
  background: white;
}

.company-name {
  font-size: 20px;
  font-weight: bold;
  text-transform: uppercase;
}

.company-text {
  font-size: 14px;
}

.report-title {
  font-size: 20px;
  text-align: center;
  margin: 8px 0;
}

.meta-box {
  border: 1px solid #000 !important;
  padding: 8px;
  font-size: 13px;
  margin: 8px 0;
}

.meta-table {
  width: 100%;
  border-collapse: collapse;
  
}

.dep-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.dep-table th,
.dep-table td {
  border: 1px solid #000;
  padding: 6px;
}

.dep-table th {
  background: #e0e0e0;
}

.total-section {
  margin: 20px 0;
}

.total-table {
  width: 100%;
  margin-bottom: 20px;
}

.remarks-section {
  margin: 20px 0;
  padding: 10px;
  border: 1px solid #ddd;
}

.signature-section {
  margin-top: 50px;
}

.signature-line {
  border-top: 1px solid #555;
  width: 200px;
  margin: 0 auto;
  text-align: center;
  color: #333;
  padding-top: 10px;
}

.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

.supplier-name {
  font-weight: bold;
}

.watermark {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 0;
  opacity: 0.1;
}

.page-header {
  margin-bottom: 20px;
}

.header-section {
  margin-bottom: 20px;
}

.company-info {
  flex: 1;
}

.logo-container {
  flex-shrink: 0;
}

.d-print-none {
  display: block !important;
}

@media print {
  .d-print-none {
    display: none !important;
  }
}
</style>